var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "GroupItemConfig" },
    [
      _c(
        "div",
        { staticClass: "group-list-header" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("分组管理")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.dialogManage(_vm.newDomainDialog).show()
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-circle-plus-outline" }),
              _vm._v("\n      添加组")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "draggable",
        _vm._b(
          {
            staticClass: "group-list-wrap",
            attrs: {
              tag: "ul",
              list: _vm.domainList,
              clone: function(config) {
                return undefined
              }
            },
            on: { end: _vm.endDraggableDomain }
          },
          "draggable",
          {
            group: { name: "domain_components", pull: "clone", put: false },
            ghostClass: "ghost"
          },
          false
        ),
        _vm._l(_vm.domainList, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "group-component-item",
              class: {
                "is-editing": _vm.domainEditManager().isEqual(item),
                domain: true
              },
              on: {
                click: function($event) {
                  return _vm.beforeEditDomain(item)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "group-label" },
                [
                  _c("i", {
                    class: ["iconfont", _vm.domainManager(item).getIcon()]
                  }),
                  _vm._v(" "),
                  _vm.domainEditManager().isEqual(item) === false ||
                  _vm.domainEditManager().getOperation() !== "name"
                    ? _c("span", { staticClass: "group-name_text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.domainManager(item).getName()) +
                            "\n        "
                        )
                      ])
                    : _c(
                        "el-form",
                        {
                          ref: "domainNameForm",
                          refInFor: true,
                          staticClass: "domain-name_form",
                          attrs: {
                            size: "mini",
                            "label-width": "0px",
                            "label-position": "left",
                            onsubmit: "return false",
                            rules: _vm.rules,
                            model: _vm.form
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "domain-name_form_item",
                              attrs: { prop: "name" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "group-name_input",
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.inputDomainName,
                                  callback: function($$v) {
                                    _vm.inputDomainName = $$v
                                  },
                                  expression: "inputDomainName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "group-operates" }, [
                _vm.domainEditManager().isEqual(item) == false
                  ? _c("i", {
                      staticClass: "el-icon-erp-edit group-rename-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.beforeEditDomainName(item)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.domainEditManager().isEqual(item) == false
                  ? _c("i", {
                      staticClass: "el-icon-erp-lajitong group-delete-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.dialogManage(_vm.deleteDomainDialog).show(item)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.domainEditManager().isEqual(item)
                  ? _c("i", {
                      staticClass: "el-icon-success group-edit-save-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submitSaveDomain.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.domainEditManager().isEqual(item)
                  ? _c("i", {
                      staticClass: "el-icon-error group-edit-cancel-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.quitEditDomain.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e()
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "confirm-dialog",
        {
          attrs: {
            title: "编辑组",
            icon: "el-icon-question",
            content:
              "是否保存" +
              (_vm.domainEditManager().getDomainName() || "模块") +
              "操作？"
          },
          model: {
            value: _vm.beforeEditConfirmDialog.visible,
            callback: function($$v) {
              _vm.$set(_vm.beforeEditConfirmDialog, "visible", $$v)
            },
            expression: "beforeEditConfirmDialog.visible"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.savePreviousEdited }
            },
            [_vm._v("确认")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "text" },
              on: { click: _vm.directGoEditingDomainStatus }
            },
            [_vm._v("取消")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "取消编辑",
            width: "384px",
            "plugin-name": "ElLeave",
            visible: _vm.cancelEditDialog.visible
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.cancelEditDialog, "visible", $event)
            }
          }
        },
        [
          _c("span", { attrs: { slot: "leave-title" }, slot: "leave-title" }, [
            _vm._v("是否确认取消？")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "leave-auxiliary" }, slot: "leave-auxiliary" },
            [_vm._v("取消后,变更内容将不再被保存")]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-question",
            attrs: { slot: "leave-icon" },
            slot: "leave-icon"
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "cancel" },
                  on: { click: _vm.quitEditingAbandonChanged }
                },
                [_vm._v("确认取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.quitEditingSaveChanged }
                },
                [_vm._v("保存数据")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.deleteDomainDialog.visible
        ? _c("el-dialog", {
            attrs: {
              visible: _vm.deleteDomainDialog.visible,
              width: "30%",
              title: "删除模块",
              "plugin-name": "ElDelete",
              "dialog-content":
                "正在进行删除操作，操作后数据无法恢复，确认继续？",
              description: "确认删除模块"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.deleteDomainDialog, "visible", $event)
              },
              "confirm-click": _vm.confirmDeleteDomain,
              "cancel-click": function($event) {
                _vm.dialogManage(_vm.deleteDomainDialog).hide()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("grace-dialog", {
        attrs: {
          "dialog:visible": _vm.newDomainDialog.visible,
          "dialog:width": "570px",
          "dialog:title": "分组保存",
          "dialog:is": "domain-save-dialog"
        },
        on: {
          "update:dialog:visible": function($event) {
            return _vm.$set(_vm.newDomainDialog, "visible", $event)
          },
          submit: _vm.submitNewDomain,
          cancel: function($event) {
            _vm.dialogManage(_vm.newDomainDialog).hide()
          }
        },
        model: {
          value: _vm.dialogManage(_vm.newDomainDialog).data,
          callback: function($$v) {
            _vm.$set(_vm.dialogManage(_vm.newDomainDialog), "data", $$v)
          },
          expression: "dialogManage(newDomainDialog).data"
        }
      }),
      _vm._v(" "),
      _c("grace-dialog", {
        attrs: {
          "dialog:visible": _vm.saveAsDialog.visible,
          "dialog:width": "570px",
          "dialog:title": "分组保存",
          "dialog:is": "domain-save-dialog"
        },
        on: {
          "update:dialog:visible": function($event) {
            return _vm.$set(_vm.saveAsDialog, "visible", $event)
          },
          submit: _vm.submitSaveAsDomain,
          cancel: _vm.cancelSaveAsDomain
        },
        model: {
          value: _vm.dialogManage(_vm.saveAsDialog).data,
          callback: function($$v) {
            _vm.$set(_vm.dialogManage(_vm.saveAsDialog), "data", $$v)
          },
          expression: "dialogManage(saveAsDialog).data"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d17cdd7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d17cdd7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Config/GroupItemConfig.vue
// module id = null
// module chunks = 